"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _formik = require("formik");
var FieldParts = _interopRequireWildcard(require("../Inputs/FieldParts"));
var _OptionToggle = _interopRequireDefault(require("../Inputs/OptionToggle"));
var _Box = _interopRequireWildcard(require("../Containers/Box"));
var _excluded = ["name", "label", "labelPosition", "children", "disabled", "automationHook", "onFormikChange", "mB"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  // Name of the field
  name: _propTypes["default"].string.isRequired,
  // Label of the field
  label: _propTypes["default"].string,
  // This will determine the label placement next to the toggle. Default: leftSpaced
  labelPosition: _propTypes["default"].oneOf(["leftSpaced", "rightSpaced", "left", "right"]),
  // Will be rendered instead of label
  children: _propTypes["default"].node,
  // Flag to disabled the field
  disabled: _propTypes["default"].bool,
  // Margin Bottom
  mB: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  // Hook used for automation testing
  automationHook: _propTypes["default"].string,
  // Extra function to call after the formik field is changed. Receives an object with value and event.
  onFormikChange: _propTypes["default"].func
  // + Other OptionToggle propTypes
};
var getPositioningProps = function getPositioningProps(labelPosition) {
  switch (labelPosition) {
    case "left":
      return {
        justifyContent: "flex-start"
      };
    case "right":
      return {
        justifyContent: "flex-end",
        direction: "row-reverse"
      };
    case "rightSpaced":
      return {
        justifyContent: "space-between",
        direction: "row-reverse"
      };
    case "leftSpaced":
    default:
      return {
        justifyContent: "space-between"
      };
  }
};
var OptionToggleFormik = function OptionToggleFormik(_ref) {
  var name = _ref.name,
    label = _ref.label,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? "leftSpaced" : _ref$labelPosition,
    children = _ref.children,
    disabled = _ref.disabled,
    automationHook = _ref.automationHook,
    onFormikChange = _ref.onFormikChange,
    mB = _ref.mB,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var hasError = meta.error && meta.touched;
  var changeHandler = function changeHandler(event, selection) {
    helpers.setValue(selection);
    helpers.setTouched(true);
    onFormikChange === null || onFormikChange === void 0 ? void 0 : onFormikChange({
      value: selection,
      event: event
    });
  };
  return /*#__PURE__*/_react["default"].createElement(FieldParts.Wrapper, {
    mB: mB
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    alignItems: "center",
    d: _Box.displayTypes.FLEX,
    gap: "xs"
  }, getPositioningProps(labelPosition)), children || label && /*#__PURE__*/_react["default"].createElement(FieldParts.Label, _extends({
    disabled: disabled,
    hasError: hasError
  }, (0, _automationHooks.hook)(automationHook, "field-label")), label), /*#__PURE__*/_react["default"].createElement(_OptionToggle["default"], _extends({}, field, {
    automationHook: automationHook,
    disabled: disabled,
    name: name,
    onChange: changeHandler
  }, rest))), hasError && /*#__PURE__*/_react["default"].createElement(FieldParts.Error, (0, _automationHooks.hook)(automationHook, "field-error"), meta.error));
};
OptionToggleFormik.propTypes = propTypes;
OptionToggleFormik.displayName = "OptionToggleFormik";
var _default = exports["default"] = OptionToggleFormik;